import "./styles.scss";

export const WidgetsContainer = ({ children }) => {
  return <div className="Widgets">{children}</div>;
};
